<template>
    <font-awesome-icon
        v-if="loading"
        icon="spinner"
        class="loading_icon"
        :spin="true"
    />
</template>

<script>
export default {
    name: 'LoadingCircle',
    props: {
        loading: Boolean,
    },
}
</script>

<style scoped>
.loading_icon {
    font-size: 40px;
    width: 100%;
    margin: 16px;
}
</style>
